module.exports = __webpack_public_path__ + "img/swap.eae161f7.svg";